import { Box, Button, Stack, Typography } from "@mui/material";
import { animated, useInView, useSpring } from "@react-spring/web";
import { Feed } from "modules/landing/components/main/components/ecosystem-section/Feed";
import { ecosystemPartnersData } from "modules/shared/data/ecosystemPartners";
import Link from "next/link";

const AnimatedBox = animated(Box);

export const PromEcosystemSection = () => {
  const [ref, isInView] = useInView({ once: true });

  const animationStyle = useSpring({
    opacity: isInView ? 1 : 0,
    transform: isInView ? "translateY(0)" : "translateY(20px)",
    from: { opacity: 0, transform: "translateY(20px)" },
    config: { tension: 150, friction: 15 },
    delay: 200,
  });
  const partners = ecosystemPartnersData.map(({ attributes }) => {
    return {
      logo:
        attributes?.landing_logo?.data?.[0]?.attributes?.url ||
        attributes?.logo?.data?.[0]?.attributes?.url,
      url: attributes?.url || "",
    };
  });

  const middleIndex = Math.floor(partners.length / 2);

  const firstHalf = partners.slice(0, middleIndex);
  const secondHalf = partners.slice(middleIndex);
  return (
    <AnimatedBox
      ref={ref}
      style={animationStyle}
      display="flex"
      flexDirection="column"
      alignItems="center"
      padding={10}
      borderRadius={8}
      gap={12}
      overflow="hidden"
      width="100%"
    >
      <Typography variant="h2">Prom ecosystem</Typography>

      <Stack gap={5} alignItems="center">
        <Feed>
          <Stack gap={5}>
            <Stack direction="row" gap={5}>
              {firstHalf.map(({ logo, url }) => {
                return (
                  <Stack
                    key={url}
                    borderRadius="12px"
                    padding={3}
                    minWidth="220px"
                    height="60px"
                    sx={{ background: "#ECECEC" }}
                  >
                    <img
                      style={{ objectFit: "contain" }}
                      width="100%"
                      height="100%"
                      loading="lazy"
                      alt="partner"
                      src={logo}
                    />
                  </Stack>
                );
              })}
            </Stack>
            <Stack direction="row" gap={5}>
              {secondHalf.map(({ url, logo }) => {
                return (
                  <Stack
                    key={url}
                    borderRadius="12px"
                    padding={3}
                    width="172px"
                    height="60px"
                    sx={{ background: "#ECECEC" }}
                  >
                    <img
                      style={{ objectFit: "contain" }}
                      width="100%"
                      height="100%"
                      loading="lazy"
                      alt="partner"
                      src={logo}
                    />
                  </Stack>
                );
              })}
            </Stack>
          </Stack>
        </Feed>
      </Stack>
      <Link legacyBehavior href="/partnership" passHref>
        <Button
          sx={{
            padding: "3.5px 41px",
          }}
          variant="outlined"
          size="small"
        >
          Explore more
        </Button>
      </Link>
    </AnimatedBox>
  );
};
